import React from "react";

const Section14Provisions = () => (
  <>
    <h2>14. General Provisions</h2>
    <p>
      <ul>
        <li>
          <strong>Force Majeure:</strong> Neither party shall be liable for any failure or delay in performance of its obligations under these Terms arising out of or caused by any circumstances beyond its reasonable control, including but not limited to acts of God, war, terrorism, riots, embargoes, strikes, lockouts, acts of civil or military authorities, fire, floods, accidents, pandemic, epidemic, or other natural disasters, and shortage of transportation, facilities, fuel, energy, labor, or materials.
        </li>
        <li>
          <strong>Waiver:</strong> The failure of either party to enforce any right or provision of these Terms shall not constitute a waiver of such right or provision.
        </li>
        <li>
          <strong>Severability:</strong> If any provision of these Terms is held to be invalid or unenforceable, such provision shall be struck and the remaining provisions shall remain in full force and effect.
        </li>
        <li>
          <strong>Entire Agreement:</strong> These Terms constitute the entire agreement between you and Comparedly Ltd. and supersede all prior and contemporaneous agreements, proposals, and communications, whether oral or written, with respect to the Service.
        </li>
        <li>
          <strong>Assignment:</strong> You may not assign your rights or obligations under these Terms without the prior written consent of Comparedly Ltd. Comparedly Ltd. may assign or transfer its rights and obligations under these Terms without your consent.
        </li>
        <li>
          <strong>Third-Party Beneficiaries:</strong> These Terms are for the benefit of, and will be enforceable by, the parties only and are not intended to confer any rights or benefits on any third party.
        </li>
        <li>
          <strong>Updates to Terms:</strong> Comparedly Ltd. reserves the right to update or modify these Terms at any time. We will provide you with notice of any material changes by posting the updated Terms on our website or through other reasonable means. Your continued use of the Service after the effective date of any changes constitutes your acceptance of the updated Terms.
        </li>
        <li>
          <strong>Use of Logo:</strong> Comparedly Ltd. may use your company name and logo in its customer lists and promotional materials with your prior consent, which may be requested separately.
        </li>
      </ul>

    </p>
  </>
);

export default Section14Provisions;
